// extracted by mini-css-extract-plugin
module.exports = {"search_item":"search-sp-box_search_item__1sSsr","individual":"search-sp-box_individual__1fqJN","name":"search-sp-box_name__2zdWR"};